// components/Header.tsx
import React from 'react';

interface HeaderProps {
  onStatsClick?: () => void;
  onHowToPlayClick?: () => void;
}

export const Header: React.FC<HeaderProps> = ({ onStatsClick, onHowToPlayClick }) => {
  return (
    <header className="w-full bg-gray-800 border-b border-gray-700 py-2">
      <div className="flex justify-between items-center px-4">
        {/* Left spacer for balance */}
        <div className="w-10"></div>

        {/* Center - Logo */}
        <div className="flex items-center">
          <img 
            src={`${process.env.PUBLIC_URL}/ReSpeLL.svg`} 
            alt="ReSpell" 
            className="h-7"
          />
        </div>

        {/* Right side - Stats and How to Play buttons */}
        <div className="flex gap-2">
          {/* How to Play button */}
          <button
            onClick={onHowToPlayClick}
            className="text-gray-300 hover:text-white p-2 rounded-lg hover:bg-gray-700 transition-colors"
            title="How to Play"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </button>

          {/* Stats button */}
          <button
            onClick={onStatsClick}
            className="text-gray-300 hover:text-white p-2 rounded-lg hover:bg-gray-700 transition-colors"
            title="Statistics"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
            </svg>
          </button>
        </div>
      </div>
    </header>
  );
};